import { useTranslation } from "react-i18next";
import { useScheduleStore } from "../../stores/schedule-store";
import { dispatchScheduleEvent, endHistoryMerge } from "../../lib/schedule-history/dispatch";
import { cn } from "../../lib/utils";
import { ScheduleDragHandle } from "./ScheduleDragHandle";
import { offlineDragId } from "./schedule-swap";
import { useScheduleSwapRow } from "./use-schedule-swap-row";
import { OfflineMessageForm } from "./OfflineMessageForm";

export function OfflineMessageRow({ dateKey, day }: { dateKey: string; day: string }) {
  const { t } = useTranslation();
  const message = useScheduleStore(state => state.offlineMessages[dateKey] ?? "");
  const active = useScheduleStore(state => state.offlineActive[dateKey] ?? false);
  const dragId = offlineDragId(dateKey);
  const row = useScheduleSwapRow(dragId, { kind: "offline", storeKey: dateKey });
  return <div ref={row.setNodeRef} style={row.style} data-swap-id={dragId}>
    <OfflineMessageForm message={message} active={active} day={day}
      onChange={(patch, merge) => dispatchScheduleEvent({ type: "offline/set", dateKey, patch }, merge ? `offline:${dateKey}` : undefined)}
      onBlur={endHistoryMerge}
      dragHandle={<ScheduleDragHandle row={row} label={`${day}, ${t("schedule.dragOfflineMessage")}`} className="h-7 shrink-0" />}
      className={cn(row.isDragging && "z-10 rounded bg-white shadow-sm ring-1 ring-neutral-300", row.isDropTarget && "rounded ring-2 ring-neutral-900 ring-offset-2")} />
  </div>;
}
